import { render, staticRenderFns } from "./project-card-carousel.vue?vue&type=template&id=74aa72a3&"
import script from "./project-card-carousel.vue?vue&type=script&lang=ts&"
export * from "./project-card-carousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74aa72a3')) {
      api.createRecord('74aa72a3', component.options)
    } else {
      api.reload('74aa72a3', component.options)
    }
    module.hot.accept("./project-card-carousel.vue?vue&type=template&id=74aa72a3&", function () {
      api.rerender('74aa72a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-card-carousel/project-card-carousel.vue"
export default component.exports